@if ($model() != null) {
    <div class="selected-grouping {{GroupingTypeClassName.get(+$model().typeId)}}">
        @for (groupingColumn of $selectedGroupingColumns(); track groupingColumn) {
            @if (groupingColumn.groupingId == $model().id) {
                <div class="selected-grouping-column column-{{+groupingColumn.innerIndex}}">
                    @for (flowObject of $selectedFlowObjects(); track flowObject) {
                        @if (flowObject.groupingColumnId == groupingColumn.id) {
                            <div matTooltipPosition="right" #selectedFlowObjectRef
                                 class="shadow-sm selected-flow-object flow-object-type {{FlowObjectTypeClassName.get(+flowObject.typeId)}}"
                                 [class.dummy-0]="flowObject.typeId == FlowObjectType.Dummy && flowObject.innerIndex == 0"
                                 [class.dummy-1]="flowObject.typeId == FlowObjectType.Dummy && flowObject.innerIndex == 1"
                                 [matTooltip]="flowObject.name"
                                 [matTooltipDisabled]="!isOverflown(selectedFlowObjectRef, flowObject.id)"
                                 [attr.data-id]="flowObject.id"
                                 (click)="toggleEditArea(flowObject)"
                                 (keyDown)="toggleEditArea(flowObject)"
                            >
                                <div class="flow-object-body-container" #flowObjectBodyContainerRef>
                                    <span class="flow-object-body">
                                        {{flowObject.name}}
                                    </span>
                                </div>

                                @if (canShowVerticalMoveButton(flowObject) && canShowMoveUpwardsButton(flowObject)) {
                                    <i class="button center top fas fa-arrow-up"
                                       matTooltip="Mover Para Sequência Anterior"
                                       matTooltipPosition="above"
                                       (click)="moveGroupingUpwards($event, flowObject)"
                                       (keyDown)="moveGroupingUpwards($event, flowObject)"
                                    ></i>
                                }

                                @if (canShowRemoveButton(flowObject)) {
                                    <i class="button remove fas fa-trash-alt"
                                       matTooltip="Remover"
                                       matTooltipPosition="right"
                                       (click)="removeGrouping($event, flowObject)"
                                       (keyDown)="removeGrouping($event, flowObject)"
                                    ></i>
                                }

                                @if (canShowChangeButton(flowObject)) {
                                    <i class="button change fas fa-exchange-alt"
                                       matTooltip="Trocar tipo da Tarefa dentre as possíveis para esta posição"
                                       matTooltipPosition="right"
                                       (click)="changeTaskType($event, flowObject)"
                                       (keyDown)="changeTaskType($event, flowObject)"
                                    ></i>
                                }

                                @if (canShowHorizontalMoveButton(flowObject) && canShowMoveBackwardsButton(flowObject)) {
                                    <i class="button left fas fa-arrow-left"
                                       matTooltip="Mover Para Trás"
                                       matTooltipPosition="left"
                                       (click)="moveGroupingBackwards($event, flowObject)"
                                       (keyDown)="moveGroupingBackwards($event, flowObject)"
                                    ></i>
                                }

                                @if (canShowVerticalMoveButton(flowObject) && canShowMoveDownwardsButton(flowObject)) {
                                    <i class="button center bottom fas fa-arrow-down"
                                       matTooltip="Mover Para Sequência Seguinte"
                                       matTooltipPosition="below"
                                       (click)="moveGroupingDownwards($event, flowObject)"
                                       (keyDown)="moveGroupingDownwards($event, flowObject)"
                                    ></i>
                                }

                                @if (canShowHorizontalMoveButton(flowObject) && canShowMoveForwardsButton(flowObject)) {
                                    <i class="button right fas fa-arrow-right"
                                       matTooltip="Mover Para Frente"
                                       matTooltipPosition="right"
                                       (click)="moveGroupingForwards($event, flowObject)"
                                       (keyDown)="moveGroupingForwards($event, flowObject)"
                                    ></i>
                                }

                                @if (flowObject.typeId != FlowObjectType.Dummy) {
                                    <div class="task-icon-container">
                                        @switch (flowObject.typeId) {
                                            @case (FlowObjectType.StartForm) {
                                                <i class="icon fas fa-file-alt"></i>
                                            }
                                            @case (FlowObjectType.FinishContent) {
                                                <i class="icon fas fa-file-alt"></i>
                                            }
                                            @case (FlowObjectType.StartInboundApi) {
                                                <i class="icon fas fa-external-link-square-alt"></i>
                                            }
                                            @case (FlowObjectType.TaskForward) {
                                                <i class="icon fas fa-paper-plane"></i>
                                            }
                                            @case (FlowObjectType.TaskAcknowledge) {
                                                <i class="icon fas fa-check"></i>
                                            }
                                            @case (FlowObjectType.TaskMidwayOutboundApi) {
                                                <i class="icon fas fa-external-link-alt"></i>
                                            }
                                            @case (FlowObjectType.FinishOutboundApi) {
                                                <i class="icon fas fa-external-link-alt"></i>
                                            }
                                            @case (FlowObjectType.TaskRegisterProcess) {
                                                <i class="icon fas fa-suitcase"></i>
                                            }
                                            @case (FlowObjectType.TaskDispatchProcess) {
                                                <i class="icon fas fa-forward"></i>
                                            }
                                            @case (FlowObjectType.TaskAddToProcess) {
                                                <i class="icon fas fa-file-import"></i>
                                            }
                                            @case (FlowObjectType.GatewayApprove) {
                                                <i class="icon fas fa-thumbs-up"></i>
                                            }
                                            @case (FlowObjectType.GatewayRules) {
                                                <i class="icon fas fa-gavel"></i>
                                            }
                                            @case (FlowObjectType.GatewayPaths) {
                                                <i class="icon fas fa-random"></i>
                                            }
                                            @case (FlowObjectType.Finish) {
                                                <i class="icon fas fa-stop-circle"></i>
                                            }
                                        }
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
            }
        }
    </div>
}
